module.exports = __webpack_public_path__ + "453259f268dc89558a51a02432b8ade0.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/layout/modulelayoutsmall.png
// module id = 786
// module chunks = 7